import { Input as ThemeInput, ThemeUIStyleObject } from "theme-ui";
import { primaryColorScales } from "../theme/styles/colors";

import React from "react";

type Props = {
  onChange?: React.ChangeEventHandler<HTMLInputElement> | undefined;
  onFocus?: React.FocusEventHandler<HTMLInputElement> | undefined;
  sx?: ThemeUIStyleObject | undefined;
  type?: string;
  value?: string;
  variant?: string;
  name?: string;
  id?: string;
  maxLength?: number;
};

export const Input: React.FC<Props> = ({
  onChange,
  sx,
  type,
  value,
  onFocus,
  variant,
  name,
  id,
  maxLength,
}) => {
  return (
    <ThemeInput
      variant={variant}
      onChange={onChange}
      onFocus={onFocus}
      maxLength={maxLength}
      sx={{
        ...sx,
        border: `0.0625rem solid ${primaryColorScales.blueScale[3]}`,
        padding: "0.5rem",
        borderRadius: "0",
      }}
      type={type}
      value={value}
      name={name}
      id={id}
    ></ThemeInput>
  );
};
